import { useEffect, useState } from "react";
import { getResourceColumnsByMultipleIds } from "../services/resourcesService";

interface IuseFetchResource {
  resourceColIds: any[];
  setIsLoading: any;
}
const useFetchResourceColumnsByMultipleIds = ({
  resourceColIds,
  setIsLoading,
}: IuseFetchResource) => {
  const [resourceColumnsData, setResourceColumnsData] = useState<any>();

  // Derive a stable sorted string key so the effect only re-runs when the
  // actual ID values change, not just the array reference.
  const sortedKey = [...(resourceColIds ?? [])].sort((a, b) => a - b).join(",");

  useEffect(() => {
    const getResourceData = async (ids: any[]) => {
      try {
        setIsLoading(true);
        const result = await getResourceColumnsByMultipleIds(ids);
        setResourceColumnsData(result);
      } catch (err) {
        setResourceColumnsData([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (sortedKey) {
      getResourceData(sortedKey.split(",").map(Number));
    }
  }, [sortedKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return [resourceColumnsData];
};

export default useFetchResourceColumnsByMultipleIds;
